<template>
  <div>
    <v-row row wrap class="text-center px-3">
      <v-col :cols="4"></v-col>
      <v-col :cols="4">
        <el-card class="box-card">
          <v-text-field
            v-model="search"
            placeholder="ค้นหาออเดอร์ : พิมพ์หมายเลขออเดอร์, ชื่อผู้สั่ง, เบอร์โทร"
            dense
            outlined
            @keydown.enter.prevent="loadOrder"
          ></v-text-field>
          <el-button type="primary" class="ml-2" size="mini" @click="viewReport"
            >ค้นหา</el-button
          >
        </el-card>
      </v-col>
      <v-col :cols="4"></v-col>
    </v-row>

    <v-row class="my-5" v-if="showStat">
      <v-col :cols="12" class="pr-0">
        <el-card class="box-card mx-3">
          <v-row>
            <v-col class="text-center">
              <strong>ยอดขาย</strong>
              <br />
              <h4 class="mt-2">฿ {{ amount.revenue | numFormat("0,0.00") }}</h4>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="text-center">
              <strong>ค่าสินค้า</strong>
              <br />
              <h4 class="mt-2">฿ {{ amount.food | numFormat("0,0.00") }}</h4>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="text-center">
              <strong>ค่าจัดส่ง</strong>
              <br />
              <h4 class="mt-2">
                ฿
                {{
                  (amount.delivery + amount.delivery_tax) | numFormat("0,0.00")
                }}
                <span class="grey--text"
                  >(฿ {{ amount.lalamove | numFormat("0,0.00") }})</span
                >
              </h4>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="text-center">
              <strong>จำนวนบิล</strong>
              <br />
              <h4 class="mt-2">
                {{
                  ((amount.completed / orderList.length) * 100)
                    | numFormat("0,0.00")
                }}%
                <span>({{ amount.completed }}/{{ orderList.length }})</span>
              </h4>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="text-center">
              <strong>จำนวนสินค้า</strong>
              <br />
              <h4 class="mt-2">
                {{ amount.quantity | numFormat("0,0") }}
              </h4>
            </v-col>
          </v-row>
        </el-card>
      </v-col>
    </v-row>
    <el-card class="mt-3 mx-3 mb-5">
      <div slot="header" class="clearfix">
        <span>&nbsp;</span>
        <el-button
          icon="fas fa-file-download"
          v-if="orderList.length > 0"
          style="float: right; padding: 3px 0"
          type="text"
          @click="downloadReport"
          >&nbsp;ดาวน์โหลด</el-button
        >
      </div>

      <v-data-table
        :headers="headers"
        :items="orderList"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:no-data>
          <div class="text-center">
            <img src="@/assets/img/no-order.png" style="width: 30%" />
          </div>
        </template>

        <template v-slot:item.order_type="{ item }">
          <div style="min-height: 60px; width: 140px">
            <div class="pt-3">
              <el-tooltip
                content="เดลิเวอรี่"
                placement="top"
                v-if="item.order_type == 'delivery'"
              >
                <i class="fas fa-motorcycle mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="คอมเมิร์ซ"
                placement="top"
                v-if="item.order_type == 'commerce'"
              >
                <i class="fas fa-shopping-bag mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="รับเองที่ร้าน"
                placement="top"
                v-if="item.order_type == 'pickup'"
              >
                <i class="fas fa-store mr-2"></i>
              </el-tooltip>

              <el-tooltip
                content="สั่งจาก POS"
                placement="top"
                v-if="['dinein', 'dinein-buffet'].includes(item.order_type)"
              >
                <i class="fas fa-desktop mr-2"></i>
              </el-tooltip>

              <span class="grey--text">{{ item.order_reference }}-</span>
              {{ item.order_id | numFormat("00000") }}
            </div>

            <div
              v-if="item.status == 'cancelled'"
              class="grey lighten-2 badge-status"
            >
              ยกเลิกแล้ว
            </div>
            <div
              v-if="item.status == 'pending'"
              class="grey darken-2 badge-status"
            >
              <i class="far fa-clock"></i> รอชำระเงิน
            </div>
            <div v-else-if="item.status == 'new'" class="red badge-status">
              มาใหม่
            </div>
            <div
              v-if="item.status == 'accepted' || item.status == 'captured'"
              class="amber darken-1 badge-status"
            >
              ยืนยันแล้ว
            </div>
            <div
              v-if="item.status == 'processing'"
              class="blue darken-2 badge-status"
            >
              ส่งให้ร้านแล้ว
            </div>
            <div
              v-if="item.status == 'cooking'"
              class="blue darken-4 badge-status"
            >
              กำลังดำเนินการ
            </div>
            <div
              v-if="item.status == 'ready-to-go'"
              class="pink lighten-3 badge-status"
            >
              พร้อมจัดส่ง
            </div>
            <div
              v-if="item.status == 'delivering'"
              class="pink lighten-1 badge-status"
            >
              กำลังจัดส่ง
            </div>
            <div
              v-if="item.status == 'completed'"
              class="green lighten-1 badge-status"
            >
              เรียบร้อยแล้ว
            </div>
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <el-button type="text" size="small" @click="openItem(item)"
            >ดูรายละเอียด <i class="far fa-external-link"></i
          ></el-button>
        </template>

        <template v-slot:item.datetime_received="{ item }">
          <!-- เวลารับอาหาร -->
          <div style="width: 150px">
            <div>{{ item.datetime_received | moment("DD/MM/YY HH:mm") }}</div>
            <div v-if="item.cluster_id != null">
              <el-tag
                v-if="
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                "
                size="mini"
                type="info"
                >รอบส่ง
                {{
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                    .delivery
                }}</el-tag
              >
            </div>
            <div v-if="item.driver_info_json != null">
              <a
                v-if="item.driver_type == 'lalamove'"
                :href="
                  `https://share.lalamove.com/?TH` +
                    item.driver_info_json.orderRef +
                    `&lang=th_TH`
                "
                target="_blank"
              >
                <img src="@/assets/img/icon-lalamove.png" style="width: 20px" />
              </a>

              <img
                v-if="item.driver_type == 'grab-instant'"
                src="@/assets/img/icon-grab-instant.png"
                style="width: 20px"
              />
            </div>
          </div>
        </template>

        <template v-slot:item.user_ref_json="{ item }">
          <!-- ข้อมูลลูกค้า -->

          <div v-if="['dinein', 'dinein-buffet'].includes(item.order_type)">
            <strong>{{ item.custom_5 }}</strong>
          </div>
          <div v-else style="width: 120px">
            <template v-if="item.user_ref_json != null">
              <strong class="line-1-elipsis"
                >{{ item.user_ref_json.firstname }}
                {{ item.user_ref_json.lastname }}</strong
              >
              <div>
                <span class="font-xs">
                  <i class="fas fa-mobile-alt"></i>
                  {{ item.user_ref_json.mobile }}
                </span>
              </div>
            </template>
          </div>
        </template>

        <template v-slot:item.delivery_info_json="{ item }">
          <!-- เส้นทาง -->
          <div style="width: 220px; padding: 10px 0">
            <ul
              class="my-progress"
              v-if="['delivery'].includes(item.order_type)"
            >
              <li class="progress__item progress__item--completed">
                <p class="progress__title">
                  <img :src="item.shop.logo_url" style="height: 22px" />
                  {{ item.shop.name }}<span> | {{ item.custom_2 }}</span>
                </p>
              </li>
              <li class="progress__item progress__item--active">
                <p class="progress__title">
                  <el-tooltip
                    v-if="item.delivery_info_json.whereTo.address.text"
                    class="item"
                    effect="dark"
                    placement="top-start"
                  >
                    <div slot="content" style="width: 200px">
                      {{ item.delivery_info_json.whereTo.address.text }}
                    </div>
                    <span>{{
                      item.delivery_info_json.whereTo.address.text
                    }}</span>
                  </el-tooltip>
                  <el-tooltip
                    v-else
                    class="item"
                    effect="dark"
                    placement="top-start"
                  >
                    <div slot="content" style="width: 200px">
                      {{ item.delivery_info_json.whereTo.address }}
                    </div>
                    <span>{{ item.delivery_info_json.whereTo.address }}</span>
                  </el-tooltip>

                  <span
                    v-if="item.distance != null && item.distance != -1"
                    class="font-xs black--text text-xs-left"
                    >(ระยะทาง
                    {{ (item.distance / 1000) | numFormat("0.00") }} km)</span
                  >
                </p>
              </li>
            </ul>
            <ul
              class="my-progress"
              v-if="['commerce'].includes(item.order_type)"
            >
              <li class="progress__item progress__item--completed">
                <p class="progress__title">
                  <img :src="item.shop.logo_url" style="height: 22px" />
                  {{ item.shop.name }}
                </p>
              </li>
              <li class="progress__item progress__item--active">
                <p class="progress__title">
                  {{ item.user_address.place_detail.address }}
                </p>
              </li>
            </ul>
            <ul class="my-progress" v-if="item.order_type == 'pickup'">
              <li class="progress__item progress__item--completed">
                <p class="progress__title">
                  <img :src="item.shop.logo_url" style="height: 22px" />
                  รับอาหารที่ร้าน {{ item.shop.name }}
                </p>
              </li>
            </ul>
            <ul
              class="my-progress"
              v-if="['dinein', 'dinein-buffet'].includes(item.order_type)"
            >
              <li class="progress__item progress__item--completed">
                <p class="progress__title">
                  <img :src="item.shop.logo_url" style="height: 22px" />
                  {{ item.shop.name }}
                </p>
              </li>
            </ul>
          </div>
        </template>

        <template v-slot:item.amount="{ item }">
          <div @click="openPaymentInfo(item)">
            <strong>฿ {{ item.amount.total | numFormat("0,0.00") }}</strong>
            <br />

            <span
              class="font-xs grey--text"
              v-if="item.payment_type == 'transfer'"
            >
              โอนเงิน
              <i
                v-if="item.payment.payment_image_url != null"
                class="far fa-file-image"
              ></i>
            </span>
            <span class="font-xs grey--text" v-if="item.payment_type == 'cash'"
              >ชำระเงินสด</span
            >
            <span
              class="font-xs grey--text"
              v-if="item.payment_type == 'creditcard'"
              >บัตรเครดิต</span
            >
          </div>
        </template>
      </v-data-table>

      <div
        style="
          position: fixed;
          bottom: 10px;
          right: 10px;
          z-index: 9;
          width: 100%;
        "
      >
        <v-pagination
          circle
          v-model="page"
          :total-visible="5"
          :length="pageCount"
        ></v-pagination>
      </div>
    </el-card>

    <payment-dialog
      :showDialog="paymentInfoDialog"
      :order="selectedOrder"
      @close="paymentInfoDialog = false"
    ></payment-dialog>
  </div>
</template>
<script>
import Service from "@/services";
import moment from "moment";

import PaymentDialog from "@/components/PaymentDialog";
export default {
  components: {
    PaymentDialog,
  },
  props: {
    shop: { default: false },
    showStat: { default: false },
    gp: { default: false },
  },
  data() {
    return {
      mode: null,
      loading: null,
      isLoading: false,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      selectedShopId: null,
      orderList: [],
      selectedOrder: null,
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
      amount: {
        revenue: 0,
        delivery: 0,
        delivery_tax: 0,
        food: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
        lalamove: 0,
      },
      permission: null,
      shopList: [],
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "order_type",
        },
        { text: "", value: "action", sortable: false },
        { text: "เวลา", value: "datetime_received", sortable: false },
        { text: "ข้อมูลลูกค้า", value: "user_ref_json", sortable: false },
        { text: "การจัดส่ง", value: "delivery_info_json", sortable: false },
        { text: "จำนวนเงิน", value: "amount", sortable: false },
        { text: "ระยะทาง", value: "distance", sortable: false },
      ],
      statusOrdering: [
        "pending",
        "new",
        "acccepted",
        "cooking",
        "processing",
        "completed",
        "cancelled",
      ],
      paymentInfoDialog: false,
      search: null,
    };
  },
  created() {
    Service.User.permission().then((resp) => {
      this.permission = resp.data;
      this.mode = this.permission.user.role_id;

      Service.Shop.gets().then((res) => {
        /*
        this.shopList = res.data.filter(function(item) {
          return item.status == "published";
        });
        */
        this.shopList = res.data;

        this.shopList.sort(function(a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
        /*
        this.shopList = this.shopList.filter(item => {
          return item.ent_id == this.permission.enterprises[0].ent_id;
        });
        */
      });
    });
  },
  methods: {
    openItem(item) {
      if (
        item.order_type == "delivery" ||
        item.order_type == "pickup" ||
        item.order_type == "dinein" ||
        item.order_type == "dinein-buffet"
      ) {
        //this.$router.push("/orders/" + item.order_reference + "/view");

        window
          .open("/orders/" + item.order_reference + "/view", "_blank")
          .focus();
      } else if (item.order_type == "commerce") {
        //this.$router.push("/commerce/view/order/" + item.order_reference);
        window
          .open("/commerce/view/order/" + item.order_reference, "_blank")
          .focus();
      }
    },
    viewReport() {
      this.showLoading();

      let params = {};

      if (this.search != null) {
        params.search = this.search;
      }

      this.amount = {
        revenue: 0,
        delivery: 0,
        delivery_tax: 0,
        food: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
        lalamove: 0,
      };
      Service.Order.search(params).then((res) => {
        this.orderList = res.data.rows;

        this.orderList.sort(
          (a, b) =>
            this.statusOrdering.indexOf(a.status) -
            this.statusOrdering.indexOf(b.status)
        );

        this.orderList.map((item) => {
          if (item.status == "completed") {
            this.amount.revenue += parseFloat(item.amount.total);
            this.amount.delivery += parseFloat(item.amount.delivery);
            this.amount.delivery_tax += parseFloat(item.amount.delivery_tax);
            this.amount.food += parseFloat(item.amount.food);
            this.amount.extra += parseFloat(item.amount.extra);
            this.amount.discount += parseFloat(item.amount.discount);
            this.amount.completed++;

            let cog = 0;

            if (
              item.order_basket.product_list != null &&
              item.order_basket.product_list.length > 0
            ) {
              item.order_basket.product_list.map((product) => {
                cog += parseInt(product.cog) * product.quantity;
                this.amount.quantity += product.quantity;
              });
            }
            item.amount.cog = cog;
            this.amount.cog += item.amount.cog;
            if (item.driver_info_json != null) {
              this.amount.lalamove +=
                parseFloat(item.amount.delivery) +
                parseFloat(item.amount.delivery_tax);
            }
          }
        });

        this.hideLoading();
      });
    },
    downloadReport() {
      this.showLoading();
      let params = {
        begin: this.daterange[0],
        end: this.daterange[1],
        report: true,
        type: "download",
      };

      if (this.selectedShopId != null) {
        params.shop_id = this.selectedShopId;
      }

      var queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
      let accessToken = vuex.Auth.accessToken;

      var request = new XMLHttpRequest();

      request.responseType = "blob";
      request.onreadystatechange = (e) => {
        let _ = this;

        let filename = "ยอดขายทั้งหมด_";
        if (this.selectedShopId != null && this.selectedShopId.length == 1) {
          filename = _.shopList.find((x) => x.shop_id == _.selectedShopId).name;
        }
        if (request.readyState !== 4) {
          return;
        }
        if (request.status === 200) {
          //console.log("success", request.response);
          var fileURL = window.URL.createObjectURL(
            new Blob([request.response], {
              type: "application/vnd.ms-excel",
            })
          );
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sale_report_" + filename + ".xls");
          document.body.appendChild(fileLink);

          _.hideLoading();
          fileLink.click();
        } else {
          console.warn(request);
        }
      };

      request.onload = function(oEvent) {
        var blob = request.response;
      };

      request.open(
        "GET",
        "https://report-api.halalize.com/delivery/orders?" + queryString
      );
      request.setRequestHeader("Content-Type", "application/json");
      request.setRequestHeader("Authorization", "Bearer " + accessToken);
      //request.setRequestHeader("Accept", "*/*");
      //request.setRequestHeader("Origin", "dev-admin.foodhunt.com");
      //request.setRequestHeader("Host", "dev-order-api.foodhunt.com");
      request.send();
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    hideLoading() {
      this.loading.close();
    },
    openPaymentInfo(item) {
      this.selectedOrder = item;
      this.paymentInfoDialog = true;
    },
  },
};
</script>
